function createJstsPolygon(geometryFactory, polygon) {
  const path = polygon.getPath();
  const coordinates = path
    .getArray()
    .map(coord => new jsts.geom.Coordinate(coord.lat(), coord.lng()));
  coordinates.push(coordinates[0]);
  const shell = geometryFactory.createLinearRing(coordinates);
  return geometryFactory.createPolygon(shell);
}

export default function checkIntersection(area1, area2) {
  const geometryFactory = new jsts.geom.GeometryFactory();
  const polygon1 = createJstsPolygon(geometryFactory, area1);
  const polygon2 = createJstsPolygon(geometryFactory, area2);
  const intersection = polygon1.intersects(polygon2);

  return intersection;
}



// WEBPACK FOOTER //
// ./src/js/logic/checkIntersection.js